import { createSelector } from '@ngrx/store';
import { selectCaseState } from './common-case.selector';

export const selectPaymentInformations = createSelector(
  selectCaseState,
  (state) => state.case.paymentInformations
);

